import React from "react";

import "./iconButton.css";

const IconButton = ({ iconName, onChange, customStyle, badgeCount }) => {
  return (
    <button className="icon-button-button" onClick={onChange} style={customStyle}>
      <i className={`bi icon-button-icon ${iconName}`}></i>

      {/* Badge - only shows if badgeCount is truthy and > 0 */}
      {badgeCount > 0 && (
        <span className="icon-button-badge">
          {badgeCount > 99 ? "99+" : badgeCount}
        </span>
      )}
    </button>
  );
};

export default IconButton;
